module.exports = __webpack_public_path__ + "p4_img6.jpg?a34fa35210b0977f7ed500d70dbd2e20";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p4/p4_img6.jpg
// module id = 113
// module chunks = 0